import withSuspense from "../../hocs/withSuspense";
import { InsuranceWithBilling as InsuranceWithBillingUnwrapped } from "./InsuranceWithBilling";
import { InsuranceWithBillingRegions } from "./InsuranceWithBillingRegions";
import { LoadingRow } from "../LoadingRow";
import { ErrorRow } from "../ErrorRow";
import { useFeatureFlag } from "../../app/Providers/AppContext";

const InsuranceWithBillingFallbackLoading = () => {
  const { BILLING } = useFeatureFlag();
  const isOldBilling = BILLING === "base";

  return (
    <InsuranceWithBillingRegions
      billingPayment={isOldBilling && <LoadingRow />}
      insurance={<LoadingRow />}
    />
  );
};

type InsuranceWithBillingFallbackProps = {
  resetErrorBoundary: () => void;
};

const InsuranceWithBillingFallback = ({
  resetErrorBoundary,
}: InsuranceWithBillingFallbackProps) => {
  const { BILLING } = useFeatureFlag();
  const isOldBilling = BILLING === "base";

  return (
    <InsuranceWithBillingRegions
      billingPayment={
        isOldBilling && <ErrorRow resetErrorBoundary={resetErrorBoundary} />
      }
      insurance={<ErrorRow resetErrorBoundary={resetErrorBoundary} />}
    />
  );
};

export const InsuranceWithBilling = withSuspense<Record<string, unknown>>(
  InsuranceWithBillingUnwrapped,
  {
    FallbackComponent: InsuranceWithBillingFallback,
    loading: <InsuranceWithBillingFallbackLoading />,
  }
);
